<template>
	<div id="pageRoot">

		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Completa cada enunciado con una de estas palabras.
		</p>

		<div class="basicItem01" id="tag01">
			<p class="textBase tagText">
				Cuando
			</p>
		</div>
		<div class="basicItem01" id="tag02">
			<p class="textBase tagText">
				y
			</p>
		</div>
		<div class="basicItem01" id="tag03">
			<p class="textBase tagText">
				porque
			</p>
		</div>

		<p class="textBase appearAnimationB" id="text02" style="z-index: 6">
			La caza, la pesca __________ la recolección de frutos eran el modo de conseguir alimento de los primeros seres humanos. Los seres humanos aceptaron a los lobos ____________ los ayudaban a cazar. ______________ terminaba la cacería, los humanos compartían su alimento con los lobos.
		</p>

		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 id="inputField03"/>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<div class="pageElement" id="fixedBackground"></div>
		<span class="footer-page footer-listen"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#fixedBackground
{
position: absolute;
width: 419px;
height: 106.02px;
left: 36px;
top: 40.95px;
background-image: url(/pages/img/sordo/svgPage90FixedBackground.svg)
}
#text01
{
position: absolute;
width: 696px;
height: 35px;
left: 78px;
top: 118px;

font-size: 24px;
line-height: 33px;

color: #000000;
}
#text02
{
position: absolute;
width: 867px;
height: 350px;
left: 70px;
top: 350px;

font-size: 33px;
line-height:60px;

color: #000000;
}
#inputField01
{
position: absolute;
width: 132px;
height: 43px;
left: 328px;
top: 343px;
font-size: 33px;
z-index: 10;
}
#inputField02
{
position: absolute;
width: 160px;
height: 43px;
left: 70px;
top: 522px;
font-size: 33px;
z-index: 10;
}
#inputField03
{
position: absolute;
width: 207px;
height: 43px;
left: 595px;
top: 522px;
font-size: 33px;
z-index: 10;
}
#tag01
{
position: absolute;
width: 189.29px;
height: 68.06px;
left: 106.71px;
top: 207.49px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage71TagShort.svg);
background-size: contain;
background-repeat: no-repeat;
}
#tag02
{
position: absolute;
width: 72px;
height: 70.55px;
left: 379px;
top: 212px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage90TagExtraSmall.svg);
background-size: contain;
background-repeat: no-repeat;
}
#tag03
{
position: absolute;
width: 196px;
height: 70.55px;
left: 534px;
top: 212px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage71TagShort.svg);
background-size: contain;
background-repeat: no-repeat;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p91/V127.mp4", "p91/V128.mp4", "p91/V129.mp4", "p91/V130.mp4", "p91/V131.mp4"]
    }
  }
}
</script>